'use client'

import { ReactNode } from 'react'
import { Spacer, Text, Image } from '@vinted/web-ui'

type Props = {
  label?: string
  messages?: Array<ReactNode>
  showSpacer?: boolean
  reportImage?: string
  avatarImageSrc?: string
  withBackground?: boolean
}

const ConversationExample = ({
  label,
  messages = [],
  showSpacer = true,
  reportImage,
  avatarImageSrc,
  withBackground = false,
}: Props) => {
  const renderMessage = (message: ReactNode, index: number) => (
    <div key={index} className="phishing-first-time-lister-education__message">
      {message}
    </div>
  )

  if (reportImage) {
    return <Image src={reportImage} alt="Report example" scaling={Image.Scaling.Contain} />
  }

  return (
    <>
      {label && <Text as="span" text={label} type={Text.Type.Body} bold />}
      {showSpacer && <Spacer size={Spacer.Size.Large} />}
      <div
        className={`phishing-first-time-lister-education__conversation${
          withBackground
            ? ' phishing-first-time-lister-education__conversation--with-background'
            : ''
        }`}
      >
        {avatarImageSrc && (
          <div className="phishing-first-time-lister-education__avatar">
            <Image src={avatarImageSrc} styling={Image.Styling.Circle} size={Image.Size.Medium} />
          </div>
        )}
        <div className="phishing-first-time-lister-education__messages-container">
          {messages.map(renderMessage)}
        </div>
      </div>
    </>
  )
}

export default ConversationExample
